import homeService, { HomeBanner, HomeTopLabels } from "@apis/homeService";
import { useAppSelector, useAppDispatch } from "@hooks/redux";
import useLanguage from "@hooks/useLanguage";
import useUserInfo from "@hooks/userInfo";
import { updateUserInfo } from "@store/globalSlice";
import { atom, useAtom } from "jotai";
import { useEffect } from "react";

export const homeBannerAtom = atom<{ status: Status; data: HomeBanner[] }>({ status: "loading", data: [] });

export const homeTopLabelAtom = atom<{ status: Status; data: HomeTopLabels[] }>({ status: "loading", data: [] });

const showAdModalAtom = atom<boolean>(false);
const modalInfoAtom = atom<{
  src: string;
  link: string;
  btnText: string;
}>({
  src: "",
  link: "",
  btnText: "",
});

const showWxMemberModalAtom = atom<boolean>(false);
const wxMemberModalInfoAtom = atom<{
  bgUrl: string;
  days: string;
  membersText: string;
}>({
  bgUrl: "",
  days: "",
  membersText: "",
});
const boundWxDataAtom = atom<HomeTopLabels | null>(null);

export const useHeaderTopLabel = () => {
  const { userInfo } = useUserInfo();
  const { isLogin } = useAppSelector((state) => state.globalReducer);
  const [topLabels, setTopLabels] = useAtom(homeTopLabelAtom);
  const [showAdModal, setShowAdModal] = useAtom(showAdModalAtom);
  const [modalInfo, setModalInfo] = useAtom(modalInfoAtom);
  const [showWxMemberModal, setShowWxMemberModal] = useAtom(showWxMemberModalAtom);
  const [wxMemberModalInfo, setWxMemberModalInfo] = useAtom(wxMemberModalInfoAtom);
  const [boundWxData, setBoundWxData] = useAtom(boundWxDataAtom);
  const dispatch = useAppDispatch();
  const { language } = useLanguage();

  const handleGetTopLabels = async () => {
    try {
      const labels = await homeService.fetchTopLabels();
      let wxAdInfo = null;
      if (isLogin && userInfo.bizCountry === "china" && userInfo.wxVerified == 0) {
        wxAdInfo = await homeService.fetchWechatHomeTopLabel();
        setBoundWxData(wxAdInfo as any);
      }

      if (!!wxAdInfo && !userInfo.subAccount) {
        if (labels && labels.length > 0) {
          setTopLabels({ status: "succeeded", data: [wxAdInfo as any, ...labels] });
        } else {
          setTopLabels({ status: "succeeded", data: [wxAdInfo as any] });
        }
      } else {
        if (labels && labels.length > 0) {
          setTopLabels({ status: "succeeded", data: labels as any });
        } else {
          setTopLabels({ status: "succeeded", data: [] });
        }
      }
    } catch (err) {
      setTopLabels({ data: [], status: "succeeded" });
    }
  };

  // 验证成功去掉微信广告
  const handleRemoveWxAd = () => {
    const newTopLabels = topLabels.data.filter((item) => item.topLabelChoose !== "WxModal");
    setTopLabels({ status: "succeeded", data: newTopLabels });
    // 更新userInfo wxVerified
    const newUserInfo = { ...userInfo, wxVerified: 1 };
    dispatch(updateUserInfo(newUserInfo));
    setBoundWxData(null);
  };

  useEffect(() => {
    if (isLogin) {
      handleGetTopLabels();
    }
  }, [isLogin, language]);

  return {
    topLabels,
    showAdModal,
    setShowAdModal,
    handleGetTopLabels,
    modalInfo,
    setModalInfo,
    showWxMemberModal,
    setShowWxMemberModal,
    wxMemberModalInfo,
    setWxMemberModalInfo,
    boundWxData,
    handleRemoveWxAd,
  };
};
